import styled from 'styled-components';

const bgColor1 = '#E9F3FD';
const bgColor2 = '#F6F6F6';
const borderColor1 = '#4080E2';
const borderColor2 = '#DADADA';

export const DateContainer = styled.div`
    display: flex;
    align-items: center;
    border-radius: 6px;
    padding: 2px;
    padding-right: 0px;
    height: 30px;
`;

export const DateText = styled.div`
    font-weight: ${({ selected }: { selected: any }) => (selected ? '600' : 'normal')};
    font-size: 12px;
    line-height: 16px;
    padding: 10px;
    cursor: pointer;
    background-color: ${({ selected }: { selected: any }) => (selected ? '#E9F3FD' : '#F6F6F6')};
    color: ${({ selected }: { selected: any }) => (selected ? '#1890ff' : 'black')};
    height: 100%;
    align-items: center;
    display: flex;
    &:hover { background: #E9F3FD; }
    &:hover { color: #1890ff; }
    border-right: 1px solid #DADADA;
    &:last-child {
      border: 0px;
    }
  }
`;

export const Range = styled.div`
  margin-top: 50px;
  position: absolute;
`;

export const DateRange = styled.div`
  display: flex;
  flex-direction: column;
  background: #F6F6F6;
  border: 1px solid #DADADA;
  box-sizing: border-box;
  border-radius: 6px;
  align-items: center;
  position: relative;
  height: 34px;
  box-sizing: border-box;
  .ant-picker.ant-picker-range {
    border: 0px;
  }
`;

export const ModalMask = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.1;
  margin: 0;
  opacity: var(--modal-light-opacity, 0.1);
  z-index: 70;
  background-color: rgb(0, 0, 0);
  background-color: var(--model-background, rgb(0, 0, 0));
  & + div {
    z-index: 71;
  }
`;

export const DisabledDate = styled.div`
  opacity: 0.45;
  pointer-events: none;
  font-size: 12px;
  line-height: 16px;
  padding: 0px 5px
  cursor: pointer;
  height: 100%;
  align-items: center;
  display: flex;
`;

export const DateIcon = styled.div`
  padding-left: 10px;
`;

export const LiveModeMarker = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
  background-color: red;
  margin-right: 5px;
`;
